import React from 'react';
import { Row, Col } from 'antd';
import clsx from 'clsx';
import COButton from 'shared/components/COButton';
import CODropdownButton from 'shared/components/CODropdownButton';
import { ButtonSize } from 'enums/ButtonEnums';
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg';
import { ReactComponent as UploadFile } from 'assets/icons/Upload File.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { commodityDropdown, tabsActiveScope } from 'enums/FarmPageEnum';
import styles from '../activityDataEntry.module.scss';

export const generateTemplateButtons = ({
  isFarmCategory,
  isEditView,
  downloadTemplate,
  toggleUploadModal,
  handleCancelClick,
  handleSave,
  activeScope,
  handleEdit,
  commodityDropdownItems,
  loading,
}: {
  isFarmCategory: boolean;
  isEditView: boolean;
  downloadTemplate: () => Promise<void>;
  toggleUploadModal: () => void;
  handleCancelClick: () => void;
  handleSave: () => Promise<void>;
  activeScope: string;
  handleEdit: () => void;
  commodityDropdownItems: {
    value: string;
    icon: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
  }[];
  loading?: boolean;
}) => (
  <Row
    className={clsx(styles.templateButtons, {
      [styles.alignButtons]: isFarmCategory,
    })}
    align="middle"
    justify="end">
    {isEditView && activeScope !== 'productionData' ? (
      <>
        <Col className={styles.button} onClick={downloadTemplate}>
          <DownloadIcon /> <span>Download Template</span>
        </Col>
        <Col onClick={toggleUploadModal} className={styles.button}>
          <UploadFile /> <span>Upload Template</span>
        </Col>
      </>
    ) : null}
    <Col>
      <Row align="middle">
        <Col>
          <div className={styles.buttonContainer}>
            {isEditView ? (
              <>
                <COButton
                  text
                  size={ButtonSize.SMALL}
                  onClick={handleCancelClick}
                  disabled={loading}>
                  Cancel
                </COButton>
                <COButton
                  primary
                  size={ButtonSize.SMALL}
                  onClick={handleSave}
                  loading={loading}>
                  Save
                </COButton>
              </>
            ) : activeScope === 'scope1' || activeScope === 'scope2' || activeScope === 'productionData' ? (
              <COButton
                text
                icon={<EditIcon />}
                onClick={handleEdit}
                size={ButtonSize.SMALL}>
                Edit
              </COButton>
            ) : null}
            {activeScope === tabsActiveScope.COMMODITY && (
              <CODropdownButton items={commodityDropdownItems}>
                {commodityDropdown.VALUE}
              </CODropdownButton>
            )}
          </div>
        </Col>
      </Row>
    </Col>
  </Row>
);
